import { TopicGroupApi, topicgroupsApi } from "api/topicgroups/topicgroupsApi";
import { useEffect, useState } from "react";

export const useTopicGroup = (topicGroupId: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<TopicGroupApi | null>(null);

  useEffect(() => {
    const fetchTopicGroup = async () => {
      if (!topicGroupId) {
        console.error("Topic group id not found.");
        setLoading(false);
        return;
      }
      const res = await topicgroupsApi.fetchById(topicGroupId);
      try {
        setData(res.data);
      } catch (error) {
        // Handle error appropriately, perhaps with another state variable
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopicGroup();
  }, [topicGroupId]);

  return { loading, data };
};
